import React from 'react';
import { NegativeActionButton, StyledActionButton, StyledPrimaryButton } from 'common';
import { useCustomPopupEvents } from 'lib/hooks';
import { Typography, useNotificationEvents } from '@agilepoint/wat-react-ux';
import { Localize, useTranslate } from '@agilepoint/wat-react';

interface IClearListProps {
    onClearList: () => Promise<Response>;
    onClearInternalState: () => void;
}

export const ClearList = React.memo((props: IClearListProps) => {
    const { onClearList, onClearInternalState } = props;
    const { showCustomPopup, removePopup } = useCustomPopupEvents();
    const { showNotifications } = useNotificationEvents();
    const onCancelClick = React.useCallback(() => removePopup('clear-app-list'), [removePopup]);
    const translate = useTranslate();

    const onOKClick = React.useCallback(() => onClearList()
        .then(() => {
            removePopup('clear-app-list');
            showNotifications({ message: translate('modules.defaultAppSettings.messages.successfulClearList'), type: 'success' });
            onClearInternalState();
        })
        .catch(() => showNotifications({ message: translate('modules.defaultAppSettings.messages.failedToClearList'), type: 'error' })), [onClearInternalState, onClearList, removePopup, showNotifications, translate]);

    const onClearListClick = React.useCallback(() => {
        showCustomPopup({
            headerTitle: translate('modules.defaultAppSettings.appList.confirmation'),
            showModal: true,
            width: '391px',
            height: '185px',
            id: 'clear-app-list',
            onRenderContent: () => <Typography.Small><Localize translate='modules.defaultAppSettings.messages.notifyToClearApplicationList' /></Typography.Small>,
            onRenderFooter: () => (
                <>
                    <StyledActionButton label={translate('common.actions.cancel')} onClick={onCancelClick} />
                    <StyledPrimaryButton label={translate('common.actions.ok')} onClick={onOKClick} />
                </>
            )
        });
    }, [onCancelClick, onOKClick, showCustomPopup, translate]);

    return (
        <NegativeActionButton label={translate('common.actions.clearList')} iconName='ap-delete.outline' onClick={onClearListClick} />
    );
});
